import React, { useRef } from 'react'
import SeoMeta from '../Common/SeoMeta'
import { getImages } from '../Common/const'
import { Link } from 'react-router-dom'
import InterestedInUsedGMC from './InterestedInUsedGMC';

const Used2015MercedesBenzC300SedanForSaleInBoerneTexas = () => {
    return (
        <>
            <SeoMeta
                title="Used 2015 Mercedes-Benz C300 Sedan For Sale In Boerne, Texas at Mark Motors"
                description="With various features and configurations, the use 2015 Mercedes-Benz C300 Sedan for sale in Boerne, Texas at Mark Motors is the base model in a line of superior, luxurious trims - C300, C300 Sport, and C300 Luxury."
                keywords="2015 Mercedes-Benz C300 Sedan For Sale in Boerne, Texas | 2015 Mercedes-Benz C300 Sedan Specials in Boerne, Texas | 2015 Mercedes-Benz C300 Sedan Dealer in Boerne, Texas | 2015 Mercedes-Benz C300 Sedan For Sale Near Boerne, Texas | 2015 Mercedes-Benz C300 Sedan in Boerne, TX"
                ogTitle="Used 2015 Mercedes-Benz C300 Sedan For Sale In Boerne, Texas at Mark Motors"
                ogDescription="With various features and configurations, the use 2015 Mercedes-Benz C300 Sedan for sale in Boerne, Texas at Mark Motors is the base model in a line of superior, luxurious trims - C300, C300 Sport, and C300 Luxury."
            />
            <section className='cm-wrap pt-200'>
                <div className='container'>
                    <div className="widget-paragraph text-start">

                        <h1><span className="s1"><strong>Used 2015 Mercedes-Benz C300 Sedan For Sale In Boerne, Texas at Mark Motors</strong></span></h1>

                        <img src={getImages('new/2015-Mercedes-Benz-C-Class-Side-2-2.jpg')} alt='Used 2015 Mercedes-Benz C300 Sedan For Sale In Boerne, Texas at Mark Motors' />
                        <p><span>The used 2015 Mercedes-Benz C300 Sedan for sale in Boerne, Texas at Mark Motors reaches far ahead in performance, refinement, and bold innovation. With space and style, the used 2015 Mercedes-Benz C300 Sedan brings you a turbocharged team of technological advances that achieve 241 hp and eager acceleration from its four efficient cylinders. With various features and configurations, the use 2015 Mercedes-Benz C300 Sedan for sale in Boerne, Texas is the base model in a line of superior, luxurious trims - C300, C300 Sport, and C300 Luxury. The used 2015 Mercedes-Benz C300 Sedan for sale in Boerne, Texas is available in ten distinct, bold exterior color options: Black, Polar White, Diamond Silver Metallic, Dakota Brown Metallic, Iridium Silver Metallic, Lunar Blue Metallic, Obsidian Black Metallic, Palladium Silver Metallic, and Diamond White Metallic. Visit us at Mark Motors in Boerne, Texas to see our inventory of used 2015 Mercedes-Benz C300 Sedan vehicles available for sale.</span><span>&nbsp;</span>
                            <span>2015 Mercedes-Benz C300 Sedan For Sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                        </p>
                        <h2><span className="s1"><strong>Overview - 2015 Mercedes-Benz C300 Sedan For Sale Near Boerne, Texas</strong></span></h2>
                        <p><span>&nbsp;</span>
                            <span>2015 Mercedes-Benz C300 Sedan For Sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                            <span><strong>Engine</strong></span>
                            <span>2.0 I-4 Engine</span>
                            <span>241 HP @ 5500 rpm</span>
                            <span>273 @ 1300 rpm Torque</span>
                            <span>&nbsp;</span>
                            <span><strong>Transmission</strong></span>
                            <span>7-Speed with/ OD Transmission</span>
                            <span>&nbsp;</span>
                            <span><strong>Drive Type</strong></span>
                            <span>Rear-Wheel Drive</span>
                            <span>&nbsp;</span>
                            <span><strong>Wheels</strong></span>
                            <span>17-inch Machined Aluminum Wheels</span>
                            <span>&nbsp;</span>
                            <span><strong>Efficiency</strong></span>
                            <span>25 city / 34 hwy / 28 combined mpg</span>
                            <span>&nbsp;</span>
                            <span>&nbsp;</span>
                        </p>
                        <h2><span className="s1"><strong>Exterior Features - 2015 Mercedes-Benz C300 Sedan Specials In Boerne, Texas</strong></span></h2>
                        <p><span>&nbsp;</span>
                            <span>2015 Mercedes-Benz C300 Sedan For Sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                            <span>Black w/ Chrome Accent Grilles.</span>
                            <span>Chrome Tip Exhaust.</span>
                            <span>Power Remote Right Side-View Door Mirror with Tilt Down.</span>
                            <span>Body-Colored Door Handles.</span>
                            <span>Auto Dimming Power Remote Left Side-View Door Mirror.</span>
                            <span>Turn Signal Indicator Mirrors.</span>
                            <span>Available Metallic Paint.</span>
                            <span>Galvanized Steel/Aluminum Body Material.</span>
                            <span>Available Remote Trunk Lid Closing System.</span>
                            <span>Power Door Mirrors.</span>
                            <span>4 Doors.</span>
                            <span>Rear Cargo Trunk.</span>
                            <span>Body-Colored Front and Rear Bumpers.</span>
                            <span>Bodyside Moldings.</span>
                            <span>Rear Bumper with Black Rub Strip.</span>
                            <span>Chrome Rear Bumper Insert.</span>
                            <span>Heated Folding Side-View Mirrors with Turn Signal Indicator.</span>
                            <span>Chrome Front Bumper Insert.</span>
                            <span>&nbsp;</span>
                            <span>Some features only available in select 2015 Mercedes-Benz C300 Sedans For Sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                            <span>&nbsp;</span>
                        </p>
                        <h2><span className="s1"><strong>Interior Features - 2015 Mercedes-Benz C300 Sedan Dealer In Boerne, Texas</strong></span></h2>
                        <p><span>&nbsp;</span>
                            <span>2015 Mercedes-Benz C300 Sedan For Sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                            <span>&nbsp;</span>
                            <span><strong>Convenience</strong></span>
                            <span>Cruise Control</span>
                            <span>Available Distance Pacing Cruise Control.</span>
                            <span>Available Control with DISTRONIC PLUS Distance Pacing.</span>
                            <span>Door Mirror Memory.</span>
                            <span>2 Setback Storage Pockets.</span>
                            <span>Passenger Power Folding Mirror.</span>
                            <span>Power Windows with Front and Rear 1-Touch Down.</span>
                            <span>Emergency Communication System mbrace2.</span>
                            <span>Power Cargo Access Remote Release.</span>
                            <span>Available Sunshade.</span>
                            <span>Integrated Key/Remote.</span>
                            <span>Rear Door Bins.</span>
                            <span>Available Panoramic Sunroof.</span>
                            <span>Air Filter.</span>
                            <span>Day-Night Rearview Mirror.</span>
                            <span>Available Trunk/Hatch Auto-Latch.</span>
                            <span>Homelink Garage Door Transmitter.</span>
                            <span>Keyfob (all doors) Remote Keyless Entry.</span>
                            <span>Available 3 Driver and Passenger Memory Seat Settings (includes door mirrors, steering wheel, head restraints).</span>
                            <span>Full Floor Console.</span>
                            <span>Driver and Passenger Door Bins.</span>
                            <span>Front Dual Zone A/C.</span>
                            <span>Available Navigation System with Voice Activation.</span>
                            <span>Automatic Temperature Control.</span>
                            <span>Retained Accessory Power.</span>
                            <span>Available Navigation System.</span>
                            <span>2 12V DC Power Outlets.</span>
                            <span>Available Panorama 1st Row Express Open/Close Sliding and Tilting Glass Sunroof.</span>
                            <span>Rear Cupholders.</span>
                            <span>Proximity Key.</span>
                            <span>Steering Wheel with Power Tilting, Power Telescoping, Auto Tilt-Away.</span>
                            <span>Illuminated Driver and Passenger-Side Visor Mirrors.</span>
                            <span>Remote Window Controls.</span>
                            <span>Available 2nd Row Sunshade.</span>
                            <span>Steering Wheel Memory.</span>
                            <span>3 Memory Settings.</span>
                            <span>Front Lighter Elements Location.</span>
                            <span>Illuminated Entry.</span>
                            <span>Available Power Glass Tilting and Sliding Sunroof.</span>
                            <span>Overhead Console.</span>
                            <span>Ashtray.</span>
                            <span>Illuminated Driver and Passenger Vanity Mirror.</span>
                            <span>Air Conditioning.</span>
                            <span>1-Touch Down.</span>
                            <span>Keyfob/Trunk/Hatch/Door Release.</span>
                            <span>Trunk/Hatch/Door FOB Controls.</span>
                            <span>Front and Rear Cupholders.</span>
                            <span>Remote Keyless Entry.</span>
                            <span>Console Ducts.</span>
                            <span>Available Hands-Free Auto-Opening Trunk/Liftgate.</span>
                            <span>Available Power Sunshade.</span>
                            <span>Full Floor Console with Covered Box.</span>
                            <span>1-Touch Up.</span>
                            <span>Driver’s Footrest.</span>
                            <span>Valet Function.</span>
                            <span>Auto-Locking Doors.</span>
                            <span>Available Power Windows.</span>
                            <span>Automatic Dual-Zone Front Air Conditioning.</span>
                            <span>Mini Overhead Console.</span>
                            <span>Window FOB Controls.</span>
                            <span>Memory Seats.</span>
                            <span>Auto-Dimming Rearview Mirror.</span>
                            <span>Head Restraints Memory.</span>
                            <span>Available Fixed Glass 2nd Row Sunroof.</span>
                            <span>Available Proximity Cargo Access Remote Release.</span>
                            <span>Telescoping Steering Wheel.</span>
                            <span>Driver Power Folding Mirror.</span>
                            <span>Illuminated Glove Box.</span>
                            <span>Illuminated Locking Glove Box.</span>
                            <span>Auto Tilt-Away Steering Wheel.</span>
                            <span>Tilt Steering Wheel.</span>
                            <span>&nbsp;</span>
                            <span>2015 Mercedes-Benz C300 Sedan For Sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                            <span><strong>Seats and Trim</strong></span>
                            <span>Rear Seat Armrest Storage.</span>
                            <span>8-Way Power Driver Seat.</span>
                            <span>Available Genuine Wood Instrument Panel Insert.</span>
                            <span>Aluminum Instrument Panel Insert, Door Panel Insert.</span>
                            <span>5 Max Seating Capacity.</span>
                            <span>Rear Seat Fold-Forward Setback.</span>
                            <span>Carpet Front and Rear Floor Mats.</span>
                            <span>Power 4-Way Driver and Passenger Lumbar Support.</span>
                            <span>Available Driver and Passenger Heated-Cushions.</span>
                            <span>Passenger Cushion Tilt.</span>
                            <span>Floor Mats.</span>
                            <span>Metal-Look Interior Accents.</span>
                            <span>Driver Cushion Tilt.</span>
                            <span>Passenger Lumbar Support.</span>
                            <span>Cargo Light.</span>
                            <span>Front Center Armrest.</span>
                            <span>Power Driver and Passenger Fore/Aft Adjustment.</span>
                            <span>Cargo Tie-Downs.</span>
                            <span>Front Bucket Seats.</span>
                            <span>Power Driver and Passenger Cushion Tilt.</span>
                            <span>Genuine Wood Console Insert.</span>
                            <span>Urethane Shift Knob.</span>
                            <span>Available Genuine Wood/Metal-Look Door Panel Insert.</span>
                            <span>Full Cloth Headliner.</span>
                            <span>Carpet Cargo Space.</span>
                            <span>8-Way Power Passenger Seat.</span>
                            <span>Leatherette Upholstery.</span>
                            <span>Bucket Front Seats.</span>
                            <span>Height Adjustable Driver Seat.</span>
                            <span>MB-Tex Leatherette Door Panel Trim.</span>
                            <span>Available Power 4-Way Passenger Lumbar Support.</span>
                            <span>Available Power Height-Adjustable Passenger Seat.</span>
                            <span>MB-Tex Leatherette Front and Rear Seat Upholstery.</span>
                            <span>Drive Lumbar Support.</span>
                            <span>Rear Bench Seat.</span>
                            <span>Available Leather Front and Rear Seat Upholstery.</span>
                            <span>Available Power Reclining Passenger Seat.</span>
                            <span>Carpet Trunk Lild/Rear Cargo Door.</span>
                            <span>Ventilated Front Seats.</span>
                            <span>Rear Seat Center Armrest with Storage.</span>
                            <span>Available Power Passenger Cushion Tilt.</span>
                            <span>Power Reclining Driver and Passenger Seats.</span>
                            <span>Rear Seat Center Armrest.</span>
                            <span>Available Driver and Passenger Heated-Setbacks.</span>
                            <span>Rear 40-20-40 Bench Seat.</span>
                            <span>Carpet Floor Covering.</span>
                            <span>Available Leather Upholstery.</span>
                            <span>Available 8-Way Passenger Seat Adjustment.</span>
                            <span>Max. Seating Capacity of 5.</span>
                            <span>Height Adjustable Passenger Seat.</span>
                            <span>Piano Black Console Insert.</span>
                            <span>Available Power Passenger Fore/Aft Adjustment.</span>
                            <span>8-Way Driver and Passenger Seat Adjustments.</span>
                            <span>Available Genuine Wood Instrument Panel Insert, Console Insert.</span>
                            <span>Power Height-Adjustable Driver and Passenger Seats.</span>
                            <span>Leather/Metal-Look Steering Wheel.</span>
                            <span>Available Heated Front Seats.</span>
                            <span>&nbsp;</span>
                            <span>Some features only available in select 2015 Mercedes-Benz C300 Sedans For Sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                        </p>
                        <h2><span className="s1"><strong>Entertainment Features - 2015 Mercedes-Benz C300 Sedan Dealer In Boerne, Texas</strong></span></h2>
                        <p><span>&nbsp;</span>
                            <span>2015 Mercedes-Benz C300 Sedan For Sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                            <span>Steering-Wheel Mounted Audio Controls.</span>
                            <span>Primary Monitor Touchscreen.</span>
                            <span>Available Digital Signal Processor.</span>
                            <span>Window Grid Antenna.</span>
                            <span>2 1st Row LCD Monitors.</span>
                            <span>Send2Benz Internet Access.</span>
                            <span>Available 590W Amplifier.</span>
                            <span>Wireless Phone Connectivity.</span>
                            <span>Available 13 Premium Speakers.</span>
                            <span>Available SiriusXM AM/FM/HD/Satellite with Seek-Scan, Single In-Dash CD Player.</span>
                            <span>Audio Theft Deterrent.</span>
                            <span>Smart Device Integration - mbrace Mobile Application.</span>
                            <span>CD Player.</span>
                            <span>Radio Data System.</span>
                            <span>Available 13 Burmeister Speakers.</span>
                            <span>AM/FM Radio.</span>
                            <span>8 Speakers.</span>
                            <span>Weather Band Radio.</span>
                            <span>Available Voice Activated Radio.</span>
                            <span>MP3 Decoder.</span>
                            <span>&nbsp;</span>
                            <span>2015 Mercedes-Benz C300 Sedan For Sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                        </p>
                        <h2><span className="s1"><strong>Lighting &amp; Instrumentation - 2015 Mercedes-Benz C300 Sedan Specials In Boerne, Texas</strong></span></h2>
                        <p><span>&nbsp;</span>
                            <span>2015 Mercedes-Benz C300 Sedan For Sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                            <span>Available Delay-Off Project Beam LED Low Beam Headlamps.</span>
                            <span>Low-Fuel Warning.</span>
                            <span>Fully Automatic Headlights.</span>
                            <span>Bulb-Failure Warning.</span>
                            <span>Low-Coolant Warning.</span>
                            <span>Front Reading Lights.</span>
                            <span>Light-Tinted Windows.</span>
                            <span>Dome Light with Fade.</span>
                            <span>Variable Intermittent Rain Detecting Wipers with Heating Jets and Reservoir.</span>
                            <span>Outside Temperature Display.</span>
                            <span>Available Power Rear Window Blind.</span>
                            <span>Variable Intermittent Wipers.</span>
                            <span>Available Auto High-Beam Headlights.</span>
                            <span>Low-Oil-Level Warning.</span>
                            <span>Delay-Off Project Beam Halogen Headlamps.</span>
                            <span>Available Camera Rear.</span>
                            <span>Available Sun Blinds.</span>
                            <span>Water Temperature Gauge.</span>
                            <span>Delay-Off Headlights.</span>
                            <span>Available Rear Window Blind.</span>
                            <span>PRE-SAFE PLUS Rear Collision.</span>
                            <span>Front and Rear Reading Lights.</span>
                            <span>Rear Reading Lights.</span>
                            <span>Brake-Fluid Warning.</span>
                            <span>Rear Fog Lights.</span>
                            <span>Trip Computer.</span>
                            <span>Compass.</span>
                            <span>Available Directionally Adaptive Headlights.</span>
                            <span>Lights-On Warning.</span>
                            <span>Redundant Digital Speedometer.</span>
                            <span>Rear Window Defroster.</span>
                            <span>Light Tinted Windows.</span>
                            <span>4 Door Curb/Courtesy Lights.</span>
                            <span>Door-Ajar Warning.</span>
                            <span>Tire Pressure Sensors.</span>
                            <span>Heated Front Windshield Wiper Jets.</span>
                            <span>Available Cornering Lights.</span>
                            <span>Head-Up Display.</span>
                            <span>Available Blind Spot Sensor.</span>
                            <span>Systems Monitor.</span>
                            <span>Automated Reverse Sensing System.</span>
                            <span>Outside-Temperature Display.</span>
                            <span>Trunk Ajar Warning.</span>
                            <span>Available Analog Clock.</span>
                            <span>Available PARKTRONIC w/Active Parking Assist Automated Parking Sensors.</span>
                            <span>Available Camera - Rear.</span>
                            <span>Available Lane Departure.</span>
                            <span>Low-Washer-Fluid Warning.</span>
                            <span>Brake Pad Wear.</span>
                            <span>Variable Instrument Panel Lighting.</span>
                            <span>Trip Odometer.</span>
                            <span>Tachometer.</span>
                            <span>Available High Intensity Discharge Headlights.</span>
                            <span>Available Rear Side Blind.</span>
                            <span>&nbsp;</span>
                            <span>Some features only available in select 2015 Mercedes-Benz C300 Sedans For Sale in Boerne, Texas.</span>
                            <span>&nbsp;</span><span>&nbsp;</span>
                        </p>
                        <h2><span className="s1"><strong>Dimensions &amp; Capacity - 2015 Mercedes-Benz C300 Sedan In Boerne, Texas</strong></span></h2>
                        <p><span>&nbsp;</span>
                            <span>2015 Mercedes-Benz C300 Sedan For Sale in Boerne, Texas.</span>
                            <span>&nbsp;</span>
                            <span>Wheelbase: 111.8 in.</span>
                            <span>Front Legroom: 41.7 in.</span>
                            <span>Front Headroom: 31.1 in.</span>
                            <span>Maximum Interior Cargo Volume: 12.6 cu. ft.</span>
                            <span>Engine Horsepower: 241-hp @ 5500 rpm.</span>
                            <span>Interior Cargo Volume: 12.6 cu. ft.</span>
                            <span>Passenger Volume: 88.2 cu. ft.</span>
                            <span>Engine Bore x Stroke: 3.3 in. X 3.6 in.</span>
                            <span>Compression Ratio: 9.80 to 1.</span>
                            <span>Engine Type: I-4.</span>
                            <span>Valves: 16.</span>
                            <span>Front Shoulder Room: 54.7 in.</span>
                            <span>Front Tread: 61.6 in.</span>
                            <span>Ground Clearance (max): 4.1 in.</span>
                            <span>Fuel Economy Highway: 34 mpg.</span>
                            <span>Engine Torque: 273 lbs.-ft. @ 1300 rpm.</span>
                            <span>Exterior Body Width: 71.3 in.</span>
                            <span>Drag Coefficient: .30</span>
                            <span>Turning Radius: 17.7 ft.</span>
                            <span>Rear Shoulder Room: 55 in.</span>
                            <span>Rear Legroom: 33.4 in.</span>
                            <span>Curb Weight: 3417 lbs.</span>
                            <span>Fuel Tank Capacity: 18 gal.</span>
                            <span>Valve Train: DOHC.</span>
                            <span>Engine Displacement: 121 cu. in.</span>
                            <span>Exterior Length: 184.5 in.</span>
                            <span>Exterior Height: 56.8 in.</span>
                            <span>Rear Tread: 60.8 in.</span>
                            <span>&nbsp;</span>
                            <span>&nbsp;</span>
                        </p>
                        <h2><span className="s1"><strong>Take Your Heart Racing - 2015 Mercedes-Benz C300 Sedan For Sale In Boerne, Texas</strong></span></h2>
                        <p>
                            <span>The 2015 Mercedes-Benz C300 Sedan for sale in Boerne, Texas at Burns Motors brings you an enhanced and refined vehicle unlike any in its class. The used 2015 Mercedes-Benz C300 combines superior engineered and the class and style that Mercedes-Benz is known for to deliver you a spacious, stylish finish with bold innovation and performance.</span>
                            <span>Visit Mark Motors in Boerne, Texas to test drive your used 2015 Mercedes-Benz C300 Sedan available for sale. Our team of experience professionals are always available to answer any questions and help you find exactly what you’re looking for.</span>
                            <span>Used 2015 Mercedes-Benz C300 Sedan for sale in Boerne, Texas.</span>
                            <span>Mark Motors proudly serves our customers in Boerne, San Antonio, Fredericksburg, and surrounding areas.</span>
                            <span>See dealer or owner's literature for limited warranty details.</span>
                        </p>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Used2015MercedesBenzC300SedanForSaleInBoerneTexas